import '../App.css';
import chip1 from '../img/chips/chip-1.svg'
import chip2 from '../img/chips/chip-2.svg'
import chip5 from '../img/chips/chip-5.svg'
import chip10 from '../img/chips/chip-10.svg'
import chip25 from '../img/chips/chip-25.svg'
import chip50 from '../img/chips/chip-50.svg'
import chip100 from '../img/chips/chip-100.svg'

function Chips(props) {

    return (
        <div class="combined-calculator__info">
            <div class="combined-calculator__info_table">
                <div class="splide">
                    <div class="splide__track">
                        <ul class="splide__list">
                            <li class={(props.activeChip === 1) ? 'splide__slide active-chip' : 'splide__slide'} data-chip="1" onClick={e => props.setActiveChip(1)}>
                                <img src={chip1} class="slider-chips__img" alt="" />
                            </li>
                            <li class={(props.activeChip === 2) ? 'splide__slide active-chip' : 'splide__slide'} data-chip="2" onClick={e => props.setActiveChip(2)}>
                                <img src={chip2} class="slider-chips__img" alt="" />
                            </li>
                            <li class={(props.activeChip === 5) ? 'splide__slide active-chip' : 'splide__slide'} data-chip="5" onClick={e => props.setActiveChip(5)}>
                                <img src={chip5} class="slider-chips__img" alt="" />
                            </li>
                            <li class={(props.activeChip === 10) ? 'splide__slide active-chip' : 'splide__slide'} data-chip="10" onClick={e => props.setActiveChip(10)}>
                                <img src={chip10} class="slider-chips__img" alt="" />
                            </li>
                            <li class={(props.activeChip === 25) ? 'splide__slide active-chip' : 'splide__slide'} data-chip="25" onClick={e => props.setActiveChip(25)}>
                                <img src={chip25} class="slider-chips__img" alt="" />
                            </li>
                            <li class={(props.activeChip === 50) ? 'splide__slide active-chip' : 'splide__slide'} data-chip="50" onClick={e => props.setActiveChip(50)}>
                                <img src={chip50} class="slider-chips__img" alt="" />
                            </li>
                            <li class={(props.activeChip === 100) ? 'splide__slide active-chip' : 'splide__slide'} data-chip="100" onClick={e => props.setActiveChip(100)}>
                                <img src={chip100} class="slider-chips__img" alt="" />
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Chips;